import React, { useEffect } from 'react';

const Status = () => {
  // Ensure scroll position is at the top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full overflow-hidden" style={{ height: 'calc(100vh - 64px)' }}>
      <iframe
        src="https://stats.uptimerobot.com/3u91erdnUb"
        width="100%"
        height="100%"
        frameBorder="0"
        title="System Status Dashboard"
        className="border-0"
        style={{
          border: 'none',
          margin: 0,
          padding: 0
        }}
      />
    </div>
  );
};

export default Status;
